import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-certificate-callback',
  templateUrl: './certificate-callback.component.html'
})
export class CertificateCallbackComponent {
  @Input() error = '';
  @Input() loading = true;

  @Output() backRequested = new EventEmitter<void>();
}
